// GeneralViews
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import NotFound from 'src/views/Pages/GeneralViews/NotFoundPage.vue';
import NotAccess from 'src/views/Pages/GeneralViews/NotAccessPage.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
// Auth
import Lock from 'src/views/Pages/Auth/Lock.vue';
// Layouts
import DashboardLayout from 'src/views/Layouts/DashboardLayout.vue';
// Pages
import Login from 'src/views/Pages/Auth/Login.vue';
// Dashboard pages
import Home from 'src/views/Pages/Dashboard/Home/Home.vue';
import User from 'src/views/Pages/Dashboard/User/UserProfile.vue';
import PasswordReset from 'src/views/Pages/Auth/PasswordReset.vue';
// Pages Maestros - Module
import Modules from 'src/views/Pages/Dashboard/Module/Modules.vue';
import ModuleCreateEdit from 'src/views/Pages/Dashboard/Module/ModuleCreateEdit.vue';
// Pages Maestros - Role
import Roles from 'src/views/Pages/Dashboard/Role/Roles.vue';
import RoleCreateEdit from 'src/views/Pages/Dashboard/Role/RoleCreateEdit.vue';
// Pages Maestros - Permission
import Permissions from 'src/views/Pages/Dashboard/Permission/Permissions.vue';
// Pages Maestros - User
import Users from 'src/views/Pages/Dashboard/User/Users.vue';
import UserCreateEdit from 'src/views/Pages/Dashboard/User/UserCreateEdit.vue';

// Pages Maestros - Business
import Businesses from 'src/views/Pages/Dashboard/Business/Businesses.vue';
import BusinessCreateEdit from 'src/views/Pages/Dashboard/Business/BusinessCreateEdit.vue';
// Pages Maestros - Areas
import AreasRoutes from 'src/views/Pages/Dashboard/Area/areas-routes';

// Pages Maestros -  Policies
import PoliciesRoutes from 'src/views/Pages/Dashboard/Policy/policies-routes';

// pages Labores
import WorksRoutes from 'src/views/Pages/Dashboard/Work/works-routes';

// pages Siembra
import SeedingRoutes from 'src/views/Pages/Dashboard/Seeding/seeding-routes';

// Pages Maestros - Sensors
import Sensors from 'src/views/Pages/Dashboard/Sensor/Sensors.vue';
import SensorsCreateEdit from 'src/views/Pages/Dashboard/Sensor/SensorsCreateEdit.vue';
// Pages Maestros - Stations
import Stations from 'src/views/Pages/Dashboard/Station/Stations.vue';
import StationsCreateEdit from 'src/views/Pages/Dashboard/Station/StationsCreateEdit.vue';
// Pages Maestros - Station Marks
import StationMarksRoutes from 'src/views/Pages/Dashboard/StationMark/station-marks-routes';
// Pages Maestros - Station Types
import StationTypesRoutes from 'src/views/Pages/Dashboard/StationType/station-types-routes';

// Pages Maestros - Devices Equipment
import Device from 'src/views/Pages/Dashboard/Device/Equipment/Devices.vue';
import DeviceCreateEdit from 'src/views/Pages/Dashboard/Device/Equipment/DevicesCreateEdit.vue';
import BloodPressureMonitors from 'src/views/Pages/Dashboard/Device/BloodPressureMonitor/BloodPressureMonitors.vue';
import BloodPressureMonitorsCreateEdit from 'src/views/Pages/Dashboard/Device/BloodPressureMonitor/BloodPressureMonitorsCreateEdit.vue';
// Pages Maestros - Types Devices
import TypeDevice from 'src/views/Pages/Dashboard/Device/Type/Types.vue';

// Pages Maestros - Audits
import Audits from 'src/views/Pages/Dashboard/Audit/Master/Audits.vue';
import AuditsCreateEdit from 'src/views/Pages/Dashboard/Audit/Master/AuditsCreateEdit.vue';
import ReportAudits from 'src/views/Pages/Dashboard/Audit/Report/Reports.vue';
import SamplingReportAudit from 'src/views/Pages/Dashboard/Audit/SamplingReport/SamplingReportAudit.vue';

//Pages Maestros - Calidad (Defectos de Calidad)
import QualityRoutes from 'src/views/Pages/Dashboard/Quality/quality-routes';

// Pages Auditoría Avanzada
import AdvancedAuditRoutes from 'src/views/Pages/Dashboard/AdvancedAudit/advanced-audit-routes';

// GIS
import FarmGis from 'src/views/Pages/Dashboard/Gis/Farm/FarmGis.vue';
import DiseaseGis from 'src/views/Pages/Dashboard/Gis/Disease/DiseaseGis.vue';
import ClimateGis from 'src/views/Pages/Dashboard/Gis/Climate/ClimateGis.vue';
import ProductionGis from 'src/views/Pages/Dashboard/Gis/Production/ProductionGis.vue';
import SatelliteGis from 'src/views/Pages/Dashboard/Gis/Satellite/SatelliteGis.vue';

import SamplesGis from 'src/views/Pages/Dashboard/Gis/Samples/GisSamples.vue';
import StationGis from 'src/views/Pages/Dashboard/Gis/Station/StationGis.vue';
// Guards
import guards from './guards';
// ----------------------------------------------- Fertilization ---------------------------------------------------------
// ApplicationGroup
import ApplicationGroup from 'src/views/Pages/Dashboard/Fertilization/ApplicationGroup/ApplicationGroup.vue';
// Nutrients
import Nutrients from 'src/views/Pages/Dashboard/Fertilization/Nutrients/Nutrients.vue';
// Fertilizers
import Fertilizer from 'src/views/Pages/Dashboard/Fertilization/Fertilizer/Fertilizer.vue';
import FertilizerCreateEdit from 'src/views/Pages/Dashboard/Fertilization/Fertilizer/FertilizerCreateEdit.vue';
// Fertilization Cycle
import FertilizationCycle from 'src/views/Pages/Dashboard/Fertilization/FertilizationCycle/FertilizationCycle.vue';
// BugetedCard
import BudgetedCard from 'src/views/Pages/Dashboard/Fertilization/BudgetedCard/BudgetedCard.vue';
import BudgetedCardCreateEdit from 'src/views/Pages/Dashboard/Fertilization/BudgetedCard/BudgetedCardCreateEdit.vue';
// BugetedCardSchedule
import BudgetedCardSchedule from 'src/views/Pages/Dashboard/Fertilization/BudgetedCardSchedule/BudgetedCardSchedule.vue';
import BudgetedCardScheduleCreateEdit from 'src/views/Pages/Dashboard/Fertilization/BudgetedCardSchedule/BudgetedCardScheduleCreateEdit.vue';
// Pages Maestros -  Calendars
import Calendar from 'src/views/Pages/Dashboard/Calendar/Calendars.vue';
import CalendarsCreateEdit from 'src/views/Pages/Dashboard/Calendar/CalendarsCreateEdit.vue';
// Pages Maestros -  Payment Calendars
/* import PaymentCalendar from 'src/views/Pages/Dashboard/PaymentCalendar/PaymentCalendars.vue';
import PaymentCalendarsCreateEdit from 'src/views/Pages/Dashboard/PaymentCalendar/PaymentCalendarsCreateEdit.vue'; */
// Pages Maestros - Cintas
import Ribbons from 'src/views/Pages/Dashboard/Ribbon/Ribbons.vue';
import RibbonsCreateEdit from 'src/views/Pages/Dashboard/Ribbon/RibbonsCreateEdit.vue';
// Pages Maestros - Causes Rejections Categories
import CausesRejectionsCategories from 'src/views/Pages/Dashboard/Rejected/CausesRejectionsCategories/CausesRejectionsCategories.vue';
import CausesRejectionsCategoriesEditCreate from 'src/views/Pages/Dashboard/Rejected/CausesRejectionsCategories/EditCreate.vue';
// Pages Maestros - Cause Rejected
import CauseRejected from 'src/views/Pages/Dashboard/Rejected/Cause/Causes.vue';
// Pages Maestros - Rejection Control Reason
import ControlReason from 'src/views/Pages/Dashboard/Rejected/Control/ControlReason.vue';
// Pages Maestros - Cause Ringing
import CauseRinging from 'src/views/Pages/Dashboard/Ringing/Cause/Causes.vue';
// Pages Maestros - Ringing Journal
import RingingJournal from 'src/views/Pages/Dashboard/Ringing/Journal/Journal.vue';
import RingingJournalReport from 'src/views/Pages/Dashboard/Ringing/Reports/Reports.vue';
import ReportByAges from 'src/views/Pages/Dashboard/Ringing/ReportByAges/ReportByAgeRoutes';
// Pages Maestros - Closing
import Closings from 'src/views/Pages/Dashboard/Closing/Closings.vue';
// Pages Embolse
import PocketCatchs from 'src/views/Pages/Dashboard/Pocket/Catch/Catchs.vue';
import PocketReports from 'src/views/Pages/Dashboard/Pocket/Report/Reports.vue';
import PocketAdvancedReportsRoutes from 'src/views/Pages/Dashboard/Pocket/AdvancedReport/advanced-report-routes';
// Pages Scales
import BoxScales from 'src/views/Pages/Dashboard/Scale/Box/Boxes.vue';
import ClusterScales from 'src/views/Pages/Dashboard/Scale/Cluster/Clusters.vue';
import BoxReport from 'src/views/Pages/Dashboard/Scale/Box/BoxReport.vue';
import ClusterReport from 'src/views/Pages/Dashboard/Scale/Cluster/ClusterReport.vue';
import ClusterVsBoxReport from 'src/views/Pages/Dashboard/Scale/ClusterVsBox/ClusterVsBoxReport.vue';
import OtherReport from 'src/views/Pages/Dashboard/Scale/Other/OtherReport.vue';
import UnsynchronizedReport from 'src/views/Pages/Dashboard/Scale/Unsynchronized/UnsynchronizedReport.vue';
import ScaleConfiguration from 'src/views/Pages/Dashboard/Scale/ScaleConfiguration/ScaleConfiguration.vue';
import Crews from 'src/views/Pages/Dashboard/Scale/Crew/Crews.vue';
import CrewsCreateEdit from 'src/views/Pages/Dashboard/Scale/Crew/CrewsCreateEdit.vue';
import Scale from 'src/views/Pages/Dashboard/Scale/Scale/Scale.vue';

// FertilizationApplication
import FertilizationApplication from 'src/views/Pages/Dashboard/Fertilization/FertilizationApplication/FertilizationApplication.vue';
import FertilizationApplicationCreateEdit from 'src/views/Pages/Dashboard/Fertilization/FertilizationApplication/FertilizationApplicationCreateEdit.vue';
// ComplianceReport
import ComplianceReport from 'src/views/Pages/Dashboard/Fertilization/ComplianceReport/ComplianceReport.vue';
// Pages Maestros - Cajas
import Box from 'src/views/Pages/Dashboard/Box/Box/Box.vue';
import BoxCreateEdit from 'src/views/Pages/Dashboard/Box/Box/BoxCreateEdit.vue';

// Pages Cajas Elaboradas
import CatchsElaborateBoxes from 'src/views/Pages/Dashboard/Box/Catch/CatchsElaborateBoxes.vue';
import ReportsElaborateBoxes from 'src/views/Pages/Dashboard/Box/Report/Reports.vue';

// Pages Maestros - Cosecha
import CreateCutting from 'src/views/Pages/Dashboard/Cutting/Create/CreateCutting.vue';
import FruitCapture from 'src/views/Pages/Dashboard/Cutting/Fruits/Capture.vue';
import FruitReports from 'src/views/Pages/Dashboard/Cutting/Report/Fruits.vue';
import Types from 'src/views/Pages/Dashboard/Cutting/Type/Types.vue';
import ProductionUnits from 'src/views/Pages/Dashboard/Cutting/ProductionUnit/ProductionUnits.vue';
import CuttingReports from 'src/views/Pages/Dashboard/Cutting/Report/CuttingReports.vue';
import CuttingAdvancedReportsRoutes from 'src/views/Pages/Dashboard/Cutting/AdvancedReport/advanced-report-routes';
import CatchGeneralCutting from '../views/Pages/Dashboard/Cutting/CatchGeneralCutting/CatchGeneralCutting.vue';

// Pages Maestros - Resumen
import FruitInventory from 'src/views/Pages/Dashboard/Summary/Report/FruitInventory.vue';
import ProductionSummary from 'src/views/Pages/Dashboard/Summary/ProductionSummary/ProductionSummary.vue';
import SummaryAuditsReport from '../views/Pages/Dashboard/Production/Summary/AuditsReport/Report.vue';
import ProductionVsClimateReport from '../views/Pages/Dashboard/Production/Summary/ProductionVsClimate/Report.vue';
// General Daily Cutting Report
import GeneralCuttingReport from '../views/Pages/Dashboard/Summary/GeneralCuttingReport/GeneralCuttingReport.vue';

// ============================= foliar =============================
import LeafNutrients from 'src/views/Pages/Dashboard/Leaf/LeafNutrients/LeafNutrients.vue';
import Leaf from 'src/views/Pages/Dashboard/Leaf/Leaf/Leaf.vue';
import LeafReport from 'src/views/Pages/Dashboard/Leaf/Reports/Reports.vue';

// ============================= agua =============================
import WaterNutrients from 'src/views/Pages/Dashboard/Water/WaterNutrients/WaterNutrients.vue';

// ==================== Lectura de Riego ===========================
import IrrigationWaterSource from 'src/views/Pages/Dashboard/IrrigationReading/IrrigationWaterSources/IrrigationWaterSources.vue';

// para Motores
import Engine from 'src/views/Pages/Dashboard/IrrigationReading/Engines/Engines.vue';
import EngineCreateEdit from 'src/views/Pages/Dashboard/IrrigationReading/Engines/EngineCreatedEdit.vue';

// Valvulas
import Valves from 'src/views/Pages/Dashboard/IrrigationReading/Valves/Valves.vue';
import ValvesCreateEdit from 'src/views/Pages/Dashboard/IrrigationReading/Valves/ValvesCreateEdit.vue';

// Captura de tensiometro
import CatchBloodPressureMonitor from 'src/views/Pages/Dashboard/IrrigationReading/BloodPressureMonitor/Catch/CatchBloodPressureMonitor.vue';
import BloodPressureMonitorReport from 'src/views/Pages/Dashboard/IrrigationReading/BloodPressureMonitor/Report/BloodPressureMonitorReport.vue';

// para Observaciones de Riego.
import Observations from 'src/views/Pages/Dashboard/IrrigationReading/IrrigationObservation/Observations.vue';

// para Captura de Riego
import Catching from 'src/views/Pages/Dashboard/IrrigationReading/IrrigationCatching/Catching.vue';

//para aguas
import WaterSources from 'src/views/Pages/Dashboard/Water/WaterSources/WaterSources.vue';
import Water from 'src/views/Pages/Dashboard/Water/Water/Water.vue';
import WaterReport from 'src/views/Pages/Dashboard/Water/Reports/Reports.vue';

// para pronóstico de riego
import IrrigationForecast from 'src/views/Pages/Dashboard/IrrigationReading/IrrigationForecast/IrrigationForecast.vue';
import IrrigationCompliance from 'src/views/Pages/Dashboard/IrrigationReading/IrrigationCompliance/IrrigationCompliance.vue';
import IrrigationSystems from 'src/views/Pages/Dashboard/IrrigationReading/IrrigationSystems/IrrigationSystems.vue';
import EnergySources from 'src/views/Pages/Dashboard/IrrigationReading/EnergySources/EnergySources.vue';

// para poda
import PruningsRoutes from '../views/Pages/Dashboard/Pruning/prunings-routes';
import StationsMap from 'src/views/Pages/Dashboard/Climate/Report/StationsMap.vue';

// para maestro comercializadoras
import Marketers from 'src/views/Pages/Dashboard/Marketer/Marketers.vue';

//para mercados
import Markets from 'src/views/Pages/Dashboard/Market/Markets.vue';
import MarketCreateEdit from 'src/views/Pages/Dashboard/Market/MarketCreateEdit.vue';

//para notificaciones
import Notifications from 'src/views/Pages/Dashboard/Notification/Notifications.vue';

// Indicador Basculas
import Indicators from 'src/views/Pages/Dashboard/Scale/Indicator/Indicators.vue';

// para captura resumen de corte
import CutSummaryCatching from 'src/views/Pages/Dashboard/Summary/CutSummary/CutSummaryCatching.vue';

// para perfil de racimos
import ProfileCluster from 'src/views/Pages/Dashboard/Summary/ProfileCluster/ProfileCluster.vue';

/* Prueba */
//Prueba de notificacion de riego
import NotificationIrrigation from 'src/views/Pages/Dashboard/IrrigationReading/Notification/notification.vue';

/* Prueba */
//Prueba de WeatherLink Api
import WeatherLinkApi from 'src/views/Pages/Dashboard/WeatherLinkApi/WeatherLinkApi.vue';

//Prueba Formulario
// para Motores
import Form from 'src/views/Pages/Dashboard/IrrigationReading/Form/Form.vue';
import FormCreateEdit from 'src/views/Pages/Dashboard/IrrigationReading/Form/FormCreateEdit.vue';

// pages Labores
import IrrigationRoutes from 'src/views/Pages/Dashboard/IrrigationReading/Irrigation/irrigationRoutes';

// pages Climate Forecast
import ClimateRoutes from 'src/views/Pages/Dashboard/Climate/climate-routes';

// pages Farms and Crops
import FarmRoutes from 'src/views/Pages/Dashboard/Farm/farm-routes';

// pages PQR
import PqrRoutes from 'src/views/Pages/Dashboard/Pqr/pqr-routes';

// pages Certifications
import CertificationsRoutes from 'src/views/Pages/Dashboard/Certifications/certifications-routes';

// pages Grounds
import GroundRoutes from 'src/views/Pages/Dashboard/Ground/ground-routes';

// pages assistance-
import AssistanceRoutes from 'src/views/Pages/Dashboard/Assistance/assistance-routes';

//pages diseases
import DiseasesRoutes from 'src/views/Pages/Dashboard/Disease/diseases-routes';

//Pages nurseries
import NurseriesRoutes from 'src/views/Pages/Dashboard/Nursery/nursery-routes';

//Pages sowings
import SowingsRoutes from 'src/views/Pages/Dashboard/Sowing/sowing-routes';

//pages RainAccumulator
import RainAccumulator from 'src/views/Pages/Dashboard/Device/RainAccumulator/RainAccumulator.vue';

//pages CatchRainAccumulator
import CatchRainAccumulator from 'src/views/Pages/Dashboard/Device/CatchRainAccumulator/CatchRainAccumulator.vue';

//pages ReportRainAccumulator
import ReportRainAccumulator from 'src/views/Pages/Dashboard/Device/ReportRainAccumulator/ReportRainAccumulator.vue';

//Pages reports sowings
import sowingReportsRoutes from 'src/views/Pages/Dashboard/SowingReports/sowing-reports-routes';

//Pages Inventory
import InventoryRoutes from 'src/views/Pages/Dashboard/Supplying/Inventory/inventory-routes';

//Pages Shopping
import ShoppingRoutes from 'src/views/Pages/Dashboard/Supplying/Shopping/shopping-routes';

//Pages Calibration
import CalibrationRoutes from 'src/views/Pages/Dashboard/Calibration/calibration-routes';

//Pages Cutting Order
import CuttingOrderRoutes from 'src/views/Pages/Dashboard/CuttingOrder/cutting-order-routes';

//Pages Range Colors
import RangeColorRoutes from 'src/views/Pages/Dashboard/RangeColor/range-color-routes';

//Microsoft AuthCallback
import AuthCallback from 'src/views/Pages/Auth/AuthCallback.vue';

//Grow
import ExternalQualityRoutes from 'src/views/Pages/Dashboard/Grow/Reports/ExternalQuality/ExternalQualityRoutes';
import LossRoutes from 'src/views/Pages/Dashboard/Grow/Reports/Loss/LossRoutes';
import OptRoutes from 'src/views/Pages/Dashboard/Grow/Captures/OPT/OptRoutes';
import BreakdownRoutes from 'src/views/Pages/Dashboard/Grow/Reports/Breakdown/breakdown-routes';
import IndividualProgressSheetRoutes from 'src/views/Pages/Dashboard/Grow/Reports/HIP/individual-progress-sheet-routes';
import SecurityRoutes from 'src/views/Pages/Dashboard/Grow/Reports/Security/security-routes';
import CompetencyMatrizRoutes from 'src/views/Pages/Dashboard/Grow/Reports/CompetencyMatriz/competency-matriz-routes';
import ActivityLogRoutes from "src/views/Pages/Dashboard/Grow/Logs/ActivityLog/ActivityLogRoutes.js";
import HourHourRoutes from 'src/views/Pages/Dashboard/Grow/Reports/HourHour/hour-hour-routes';
import LogPlannerRoutes from 'src/views/Pages/Dashboard/Grow/LogPlanner/log-planner-routes';
import FinishedProductQualityRoutes from 'src/views/Pages/Dashboard/Grow/Reports/FinishedProductQuality/finished-product-quality-routes';
import HarvestQualityRoutes from 'src/views/Pages/Dashboard/Grow/Reports/HarvestQuality/harvest-quality-routes';
import PresentismRoutes from 'src/views/Pages/Dashboard/Grow/Reports/Presentism/presentism-routes';
import ProfitExportedBoxesRoutes from 'src/views/Pages/Dashboard/Grow/Reports/ProfitExportedBoxes/profit-exported-boxes-routes';
import ActivityCompletionRoutes from 'src/views/Pages/Dashboard/Grow/Reports/ActivityCompletion/activity-completion-routes';

//ProductionBudget
import ProductionBudgetRoutes from 'src/views/Pages/Dashboard/ProductionBudget/production-budget-routes'

//EvaluationLeaves
import SigatokaRouters from 'src/views/Pages/Dashboard/Sigatoka/sigatoka-routes.js';

//Log Reports
import LogReportsRoutes from 'src/views/Pages/Dashboard/Log/log-reports-routes';

/**
 * En este script crearemos nuestras rutas, definiendo los componentes
 * a donde apuntan y los guards a aplicar sobre las mismas.
 *
 */
// creamos nuestra ruta homePage, con sus respectivas rutas hijas
let homePage = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: guards.guest,
  redirect: '/home',
  children: [
    {
      path: 'notaccess',
      name: 'Acceso Restringido',
      component: NotAccess,
    },
    {
      path: 'home',
      name: 'common_words.board',
      component: Home,
    },
    {
      path: 'profile',
      name: 'common_words.my_profile',
      component: User,
    },
    FarmRoutes,
    {
      path: 'businesses',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.companies',
          component: Businesses,
          meta: {
            prefix_permission: 'businesses',
          },
        },
        {
          path: 'create',
          name: 'common_words.companies',
          component: BusinessCreateEdit,
          meta: {
            prefix_permission: 'businesses',
          },
        },
        {
          path: 'edit',
          name: 'common_words.companies',
          component: BusinessCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'businesses',
          },
        },
      ],
    },
    {
      path: 'markets',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'config.markets',
          component: Markets,
          meta: {
            prefix_permission: 'markets',
          },
        },
        {
          path: 'create',
          name: 'config.markets',
          component: MarketCreateEdit,
          meta: {
            prefix_permission: 'markets',
          },
        },
        {
          path: 'edit',
          name: 'config.markets',
          component: MarketCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'markets',
          },
        },
      ],
    },
    {
      path: 'notifications',
      name: 'common_words.notifications',
      component: Notifications,
      meta: {
        prefix_permission: 'notifications',
      },
    },
    {
      path: 'marketers',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Comercializadoras',
          component: Marketers,
          meta: {
            prefix_permission: 'marketers',
          },
        },
      ],
    },
    AreasRoutes,
    PoliciesRoutes,
    AdvancedAuditRoutes,
    WorksRoutes,
    QualityRoutes,
    PqrRoutes,
    ClimateRoutes,
    SeedingRoutes,
    PruningsRoutes,
    AssistanceRoutes,
    DiseasesRoutes,
    NurseriesRoutes,
    SowingsRoutes,
    sowingReportsRoutes,
    InventoryRoutes,
    ShoppingRoutes,
    CalibrationRoutes,
    CuttingOrderRoutes,
    RangeColorRoutes,
    SigatokaRouters,
    LogReportsRoutes,
    ProductionBudgetRoutes,
    {
      path: 'devices',
      component: MasterTab,
      props: { reference: 'deviceTabs' },
      children: [
        {
          path: 'stationsmap',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'devices.devices_sensors',
              component: StationsMap,
              meta: {
                prefix_permission: 'climates_stationsmap',
              },
            },
          ],
        },
        {
          path: 'stations',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'devices.devices_sensors',
              component: Stations,
              meta: {
                prefix_permission: 'devices_stations',
              },
            },
            {
              path: 'create',
              name: 'devices.devices_sensors',
              component: StationsCreateEdit,
              meta: {
                prefix_permission: 'devices_stations',
              },
            },
            {
              path: 'edit',
              name: 'devices.devices_sensors',
              component: StationsCreateEdit,
              meta: {
                prefix_permission: 'devices_stations',
              },
            },
          ],
        },
        StationMarksRoutes,
        StationTypesRoutes,
        {
          path: 'sensors',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'devices.devices_sensors',
              component: Sensors,
              meta: {
                prefix_permission: 'devices_sensors',
              },
            },
            {
              path: 'create',
              name: 'devices.devices_sensors',
              component: SensorsCreateEdit,
              meta: {
                prefix_permission: 'devices_sensors',
              },
            },
            {
              path: 'edit',
              name: 'devices.devices_sensors',
              component: SensorsCreateEdit,
              meta: {
                prefix_permission: 'devices_sensors',
              },
            },
          ],
        },
        {
          path: 'equipments',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'devices.devices_sensors',
              component: Device,
              meta: {
                prefix_permission: 'devices_equipments',
              },
            },
            {
              path: 'create',
              name: 'devices.devices_sensors',
              component: DeviceCreateEdit,
              meta: {
                prefix_permission: 'devices_equipments',
              },
            },
            {
              path: 'edit',
              name: 'devices.devices_sensors',
              component: DeviceCreateEdit,
              meta: {
                prefix_permission: 'devices_equipments',
              },
            },
          ],
        },
        {
          path: 'types',
          name: 'devices.devices_sensors',
          component: TypeDevice,
          meta: {
            prefix_permission: 'devices_types',
          },
        },
        {
          path: 'bloodpressuremonitors',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'devices.blood_pressure_monitors',
              component: BloodPressureMonitors,
              meta: {
                prefix_permission: 'devices_bloodpressuremonitors',
              },
            },
            {
              path: 'create',
              name: 'devices.blood_pressure_monitors',
              component: BloodPressureMonitorsCreateEdit,
              meta: {
                prefix_permission: 'devices_bloodpressuremonitors',
              },
            },
            {
              path: 'edit',
              name: 'devices.blood_pressure_monitors',
              component: BloodPressureMonitorsCreateEdit,
              meta: {
                prefix_permission: 'devices_bloodpressuremonitors',
              },
            },
          ],
        },
        //RainAccumulator
        {
          path: 'rainaccumulators',
          name: 'devices.devices_sensors',
          component: RainAccumulator,
          meta: {
            prefix_permission: 'devices_rainaccumulators',
          },
        },
        //CatchRainAccumulator
        {
          path: 'catchrainaccumulators',
          name: 'common_words.climate',
          component: CatchRainAccumulator,
          meta: {
            prefix_permission: 'devices_catchrainaccumulators',
          },
        },
        //ReportRainAccumulator
        {
          path: 'reportrainaccumulators',
          name: 'common_words.climate',
          component: ReportRainAccumulator,
          meta: {
            prefix_permission: 'devices_reportrainaccumulators',
          },
        },
        /**Prueba weatherLink Api */
        {
          path: 'weatherlinkapi',
          name: 'devices.devices_sensors',
          component: WeatherLinkApi,
          meta: {
            prefix_permission: 'devices_weatherlinkapi',
          },
        },
      ],
    },
    {
      path: 'modules',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.modules',
          component: Modules,
          meta: {
            prefix_permission: 'modules',
          },
        },
        {
          path: 'create',
          name: 'common_words.modules',
          component: ModuleCreateEdit,
          meta: {
            prefix_permission: 'modules',
          },
        },
        {
          path: 'edit',
          name: 'common_words.modules',
          component: ModuleCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'modules',
          },
        },
      ],
    },
    {
      path: 'roles',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.profiles',
          component: Roles,
          meta: {
            prefix_permission: 'roles',
          },
        },
        {
          path: 'create',
          name: 'common_words.profiles',
          component: RoleCreateEdit,
          meta: {
            prefix_permission: 'roles',
          },
        },
        {
          path: 'edit',
          name: 'common_words.profiles',
          component: RoleCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'roles',
          },
        },
      ],
    },
    {
      path: 'permissions',
      name: 'common_words.permits',
      component: Permissions,
      meta: {
        prefix_permission: 'permissions',
      },
    },
    {
      path: 'users',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.users',
          component: Users,
          meta: {
            prefix_permission: 'users',
          },
        },
        {
          path: 'create',
          name: 'common_words.users',
          component: UserCreateEdit,
          meta: {
            prefix_permission: 'users',
          },
        },
        {
          path: 'edit',
          name: 'common_words.users',
          component: UserCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'users',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: MasterTab,
      props: { reference: 'auditTabs' },
      children: [
        {
          path: 'inspections',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'audit.basic_audit',
              component: ReportAudits,
              meta: {
                prefix_permission: 'audits_inspections',
              },
            },
          ],
        },
        {
          path: 'samplingreport',
          name: 'audit.basic_audit',
          component: SamplingReportAudit,
          meta: {
            prefix_permission: 'audits_samplingreport',
          },
        },
        {
          path: 'audits',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'audit.basic_audit',
              component: Audits,
              meta: {
                prefix_permission: 'audits_audits',
              },
            },
            {
              path: 'create',
              name: 'audit.basic_audit',
              component: AuditsCreateEdit,
              meta: {
                prefix_permission: 'audits_audits',
              },
            },
            {
              path: 'edit',
              name: 'audit.basic_audit',
              component: AuditsCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'audits_audits',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'gis',
      component: MasterTab,
      props: { reference: 'gisTabs' },
      children: [
        {
          path: 'diseases',
          name: 'GIS',
          component: DiseaseGis,
          meta: {
            prefix_permission: 'gis_diseases',
          },
        },
        {
          path: 'farmsgis',
          name: 'GIS',
          component: FarmGis,
          meta: {
            prefix_permission: 'gis_farmsgis',
          },
        },
        {
          path: 'production',
          name: 'GIS',
          component: ProductionGis,
          meta: {
            prefix_permission: 'gis_production',
          },
        },
        {
          path: 'climates',
          name: 'GIS',
          component: ClimateGis,
          meta: {
            prefix_permission: 'gis_climates',
          },
        },
        {
          path: 'samples',
          name: 'GIS',
          component: SamplesGis,
          meta: {
            prefix_permission: 'gis_samples',
          },
        },
        {
          path: 'stationgis',
          name: 'GIS',
          component: StationGis,
          meta: {
            prefix_permission: 'gis_stationgis',
          },
        },
        {
          path: 'satellite',
          name: 'GIS',
          component: SatelliteGis,
          meta: {
            prefix_permission: 'gis_satellite',
          },
        },
      ],
    },
    {
      path: 'fertilization',
      component: MasterTab,
      props: { reference: 'fertilizationTabs' },
      children: [
        {
          path: 'applicationgroups',
          name: 'fertilization.fertilization',
          component: ApplicationGroup,
          meta: {
            prefix_permission: 'fertilization_applicationgroups',
          },
        },
        {
          path: 'nutrients',
          name: 'fertilization.fertilization',
          component: Nutrients,
          meta: {
            prefix_permission: 'fertilization_nutrients',
          },
        },
        {
          path: 'fertilizers',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'fertilization.fertilization',
              component: Fertilizer,
              meta: {
                prefix_permission: 'fertilization_fertilizers',
              },
            },
            {
              path: 'create',
              name: 'fertilization.fertilization',
              component: FertilizerCreateEdit,
              meta: {
                prefix_permission: 'fertilization_fertilizers',
              },
            },
            {
              path: 'edit',
              name: 'fertilization.fertilization',
              component: FertilizerCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'fertilization_fertilizers',
              },
            },
          ],
        },
        {
          path: 'fertilization_cycles',
          name: 'fertilization.fertilization',
          component: FertilizationCycle,
          meta: {
            prefix_permission: 'fertilization_fertilization_cycles',
          },
        },
        {
          path: 'budgeted_cards',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'fertilization.fertilization',
              component: BudgetedCard,
              meta: {
                prefix_permission: 'fertilization_budgeted_cards',
              },
            },
            {
              path: 'create',
              name: 'fertilization.fertilization',
              component: BudgetedCardCreateEdit,
              meta: {
                prefix_permission: 'fertilization_budgeted_cards',
              },
            },
            {
              path: 'edit',
              name: 'fertilization.fertilization',
              component: BudgetedCardCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'fertilization_budgeted_cards',
              },
            },
          ],
        },
        {
          path: 'budgeted_card_schedules',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'fertilization.fertilization',
              component: BudgetedCardSchedule,
              meta: {
                prefix_permission: 'fertilization_budgeted_card_schedules',
              },
            },
            {
              path: 'show',
              name: 'fertilization.fertilization',
              component: BudgetedCardScheduleCreateEdit,
              meta: {
                prefix_permission: 'fertilization_budgeted_card_schedules',
              },
            },
            {
              path: 'create',
              name: 'fertilization.fertilization',
              component: BudgetedCardScheduleCreateEdit,
              meta: {
                prefix_permission: 'fertilization_budgeted_card_schedules',
              },
            },
            {
              path: 'edit',
              name: 'fertilization.fertilization',
              component: BudgetedCardScheduleCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'fertilization_budgeted_card_schedules',
              },
            },
          ],
        },
        {
          path: 'fertilization_application',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'fertilization.fertilization',
              component: FertilizationApplication,
              meta: {
                prefix_permission: 'fertilization_fertilization_application',
              },
            },
            {
              path: 'create',
              name: 'fertilization.fertilization',
              component: FertilizationApplicationCreateEdit,
              meta: {
                prefix_permission: 'fertilization_fertilization_application',
              },
            },
            {
              path: 'edit',
              name: 'fertilization.fertilization',
              component: FertilizationApplicationCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'fertilization_fertilization_application',
              },
            },
          ],
        },
        {
          path: 'compliancereport',
          name: 'fertilization.fertilization',
          component: ComplianceReport,
          meta: {
            prefix_permission: 'fertilization_compliancereport',
          },
        },
      ],
    },
    {
      path: 'calendars',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.calendars',
          component: Calendar,
          meta: {
            prefix_permission: 'calendars',
          },
        },
        {
          path: 'create',
          name: 'common_words.calendars',
          component: CalendarsCreateEdit,
          meta: {
            prefix_permission: 'calendars',
          },
        },
        {
          path: 'edit',
          name: 'common_words.calendars',
          component: CalendarsCreateEdit,
          meta: {
            prefix_permission: 'calendars',
          },
        },
      ],
    },
    /* 
    * Esto por el momento comentado, porque aqui es donde va ubicado, pero aun no se
    * ha definido el criterio de donde se ubicará
    {
      path: 'paymentcalendars',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.payment_calendars',
          component: PaymentCalendar,
          meta: {
            prefix_permission: 'paymentcalendars',
          },
        },
        {
          path: 'create',
          name: 'common_words.payment_calendars',
          component: PaymentCalendarsCreateEdit,
          meta: {
            prefix_permission: 'paymentcalendars',
          },
        },
        {
          path: 'edit',
          name: 'common_words.payment_calendars',
          component: PaymentCalendarsCreateEdit,
          meta: {
            prefix_permission: 'paymentcalendars',
          },
        },
      ],
    }, */
    {
      path: 'cutting',
      component: MasterTab,
      props: { reference: 'cuttingTabs' },
      children: [
        {
          path: 'cuts',
          name: 'sowing.harvest',
          component: CreateCutting,
          meta: {
            prefix_permission: 'cutting_cuts',
          },
        },
        {
          path: 'fruits',
          name: 'sowing.harvest',
          component: FruitCapture,
          meta: {
            prefix_permission: 'cutting_fruits',
          },
        },
        {
          path: 'fruitsreports',
          name: 'sowing.harvest',
          component: FruitReports,
          meta: {
            prefix_permission: 'cutting_fruits',
          },
        },
        {
          path: 'reports',
          name: 'sowing.harvest',
          component: CuttingReports,
          meta: {
            prefix_permission: 'cutting_reports',
          },
        },
        {
          path: 'types',
          name: 'sowing.harvest',
          component: Types,
          meta: {
            prefix_permission: 'cutting_types',
          },
        },
        {
          path: 'productionunits',
          name: 'sowing.harvest',
          component: ProductionUnits,
          meta: {
            prefix_permission: 'cutting_productionunits',
          },
        },
        CuttingAdvancedReportsRoutes,
        {
          path: 'generalcuttingcatch',
          name: 'production.general_cutting_inform',
          component: CatchGeneralCutting,
          meta: {
            prefix_permission: 'cutting_generalcuttingcatch',
          },
        },
      ],
    },
    {
      path: 'summary',
      component: MasterTab,
      props: { reference: 'summaryTabs' },
      children: [
        {
          path: 'fruitinventory',
          name: 'production.fruit_inventory',
          component: FruitInventory,
          meta: {
            prefix_permission: 'summary_fruitinventory',
          },
        },
        {
          path: 'productionsummary',
          name: 'production.production_summary',
          component: ProductionSummary,
          meta: {
            prefix_permission: 'summary_productionsummary',
          },
        },
        {
          path: 'cutsummarycatching',
          name: 'production.production_summary',
          component: CutSummaryCatching,
          meta: {
            prefix_permission: 'summary_cutsummarycatching',
          },
        },
        {
          path: 'profilecluster',
          name: 'production.cluster_fruit_profile',
          component: ProfileCluster,
          meta: {
            prefix_permission: 'summary_profilecluster',
          },
        },
        {
          path: 'auditsreport',
          name: 'production.audits_report',
          component: SummaryAuditsReport,
          meta: {
            prefix_permission: 'summary_auditsreport',
          },
        },
        {
          path: 'productionvsclimate',
          name: 'production.production_vs_climate_report',
          component: ProductionVsClimateReport,
          meta: {
            prefix_permission: 'summary_productionvsclimate',
          },
        },
        {
          path: 'generalcuttingreport',
          name: 'production.general_cutting_report',
          component: GeneralCuttingReport,
          meta: {
            prefix_permission: 'summary_generalcuttingreport',
          },
        },
      ],
    },
    {
      path: 'ribbons',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'production.ribbon',
          component: Ribbons,
          meta: {
            prefix_permission: 'ribbons',
          },
        },
        {
          path: 'create',
          name: 'production.ribbon',
          component: RibbonsCreateEdit,
          meta: {
            prefix_permission: 'ribbons',
          },
        },
        {
          path: 'edit',
          name: 'production.ribbon',
          component: RibbonsCreateEdit,
          meta: {
            prefix_permission: 'ribbons',
          },
        },
      ],
    },
    {
      path: 'rejecteds',
      component: MasterTab,
      props: { reference: 'rejectedsTabs' },
      children: [
        {
          path: 'categories',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'production.rejected',
              component: CausesRejectionsCategories,
              meta: {
                prefix_permission: 'rejecteds_categories',
              },
            },
            {
              path: 'create',
              name: 'production.rejected',
              component: CausesRejectionsCategoriesEditCreate,
              meta: {
                prefix_permission: 'rejecteds_categories',
              },
            },
            {
              path: 'edit',
              name: 'production.rejected',
              component: CausesRejectionsCategoriesEditCreate,
              meta: {
                prefix_permission: 'rejecteds_categories',
              },
            },
          ],
        },
        {
          path: 'causes',
          name: 'production.rejected',
          component: CauseRejected,
          meta: {
            prefix_permission: 'rejecteds_causes',
          },
        },
        {
          path: 'reasonscontrol',
          name: 'production.rejected',
          component: ControlReason,
          meta: {
            prefix_permission: 'rejecteds_reasonscontrol',
          },
        },
      ],
    },
    {
      path: 'ringings',
      component: MasterTab,
      props: { reference: 'ringingsTabs' },
      children: [
        {
          path: 'causes',
          name: 'production.ringings',
          component: CauseRinging,
          meta: {
            prefix_permission: 'ringings_causes',
          },
        },
        {
          path: 'journals',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'production.ringings',
              component: RingingJournal,
              meta: {
                prefix_permission: 'ringings_journals',
              },
            },
            ReportByAges,
          ],
        },
        {
          path: 'reports',
          name: 'production.ringings',
          component: RingingJournalReport,
          meta: {
            prefix_permission: 'ringings_reports',
          },
        },
      ],
    },
    {
      path: 'closings',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'production.closings',
          component: Closings,
          meta: {
            prefix_permission: 'closings',
          },
        },
      ],
    },
    {
      path: 'pockets',
      component: MasterTab,
      props: { reference: 'pocketTabs' },
      children: [
        {
          path: 'catchs',
          name: 'production.baggd',
          component: PocketCatchs,
          meta: {
            prefix_permission: 'pockets_catchs',
          },
        },
        {
          path: 'reports',
          name: 'production.baggd',
          component: PocketReports,
          meta: {
            prefix_permission: 'pockets_reports',
          },
        },
        PocketAdvancedReportsRoutes,
      ],
    },
    {
      path: 'boxes',
      component: MasterTab,
      props: { reference: 'boxesTabs' },
      children: [
        {
          path: 'catchs',
          name: 'production.crafted_boxes',
          component: CatchsElaborateBoxes,
          meta: {
            prefix_permission: 'boxes_catchs',
          },
        },
        {
          path: 'reports',
          name: 'production.crafted_boxes',
          component: ReportsElaborateBoxes,
          meta: {
            prefix_permission: 'boxes_reports',
          },
        },
        {
          path: 'boxes',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'production.box',
              component: Box,
              meta: {
                prefix_permission: 'boxes_boxes',
              },
            },
            {
              path: 'create',
              name: 'production.box',
              component: BoxCreateEdit,
              meta: {
                prefix_permission: 'boxes_boxes',
              },
            },
            {
              path: 'edit',
              name: 'production.box',
              component: BoxCreateEdit,
              meta: {
                prefix_permission: 'boxes_boxes',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'scales',
      component: MasterTab,
      props: { reference: 'scaleTabs' },
      children: [
        {
          path: 'indicators',
          name: 'production.scale',
          component: Indicators,
          meta: {
            prefix_permission: 'scales_indicators',
          },
        },
        {
          path: 'boxes',
          name: 'production.scale',
          component: BoxScales,
          meta: {
            prefix_permission: 'scales_boxes',
          },
        },
        {
          path: 'boxes/reports',
          name: 'production.scale',
          component: BoxReport,
          meta: {
            prefix_permission: 'scales_boxes_reports',
          },
        },
        {
          path: 'clusters',
          name: 'production.scale',
          component: ClusterScales,
          meta: {
            prefix_permission: 'scales_clusters',
          },
        },
        {
          path: 'clusters/reports',
          name: 'production.scale',
          component: ClusterReport,
          meta: {
            prefix_permission: 'scales_clusters_reports',
          },
        },
        {
          path: 'clusters/vsreports',
          name: 'production.scale',
          component: ClusterVsBoxReport,
          meta: {
            prefix_permission: 'scales_clusters_vsreports',
          },
        },
        {
          path: 'others/reports',
          name: 'production.scale',
          component: OtherReport,
          meta: {
            prefix_permission: 'scales_others_reports',
          },
        },
        {
          path: 'unsynchronized/reports',
          name: 'production.scale',
          component: UnsynchronizedReport,
          meta: {
            prefix_permission: 'scales_unsynchronized_reports',
          },
        },
        {
          path: 'configurations',
          name: 'production.scale',
          component: ScaleConfiguration,
          meta: {
            prefix_permission: 'scales_configurations',
          },
        },
        {
          path: 'tablets',
          name: 'devices.tablets',
          component: Scale,
          meta: {
            prefix_permission: 'scales_tablets',
          },
        },
        {
          path: 'crews',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'production.crews',
              component: Crews,
              meta: {
                prefix_permission: 'scales_crews',
              },
            },
            {
              path: 'create',
              name: 'production.crews',
              component: CrewsCreateEdit,
              meta: {
                prefix_permission: 'scales_crews',
              },
            },
            {
              path: 'edit',
              name: 'production.crews',
              component: CrewsCreateEdit,
              meta: {
                prefix_permission: 'scales_crews',
              },
            },
          ],
        },
      ],
    },
    CertificationsRoutes,
    GroundRoutes,
    {
      path: 'leafs',
      component: MasterTab,
      props: { reference: 'leafsTabs' },
      children: [
        {
          path: 'nutrients',
          name: 'samples.foliage',
          component: LeafNutrients,
          meta: {
            prefix_permission: 'leafs_nutrients',
          },
        },
        {
          path: 'leafs',
          name: 'samples.foliage',
          component: Leaf,
          meta: {
            prefix_permission: 'leafs_leafs',
          },
        },
        {
          path: 'reports',
          name: 'samples.foliage',
          component: LeafReport,
          meta: {
            prefix_permission: 'leafs_reports',
          },
        },
      ],
    },
    {
      path: 'waters',
      component: MasterTab,
      props: { reference: 'watersTabs' },
      children: [
        {
          path: 'nutrients',
          name: 'samples.waters',
          component: WaterNutrients,
          meta: {
            prefix_permission: 'waters_nutrients',
          },
        },
        {
          path: 'sources',
          name: 'samples.waters',
          component: WaterSources,
          meta: {
            prefix_permission: 'waters_sources',
          },
        },
        {
          path: 'waters',
          name: 'samples.waters',
          component: Water,
          meta: {
            prefix_permission: 'waters_waters',
          },
        },
        {
          path: 'reports',
          name: 'samples.waters',
          component: WaterReport,
          meta: {
            prefix_permission: 'waters_reports',
          },
        },
      ],
    },
    {
      path: 'irrigation',
      component: MasterTab,
      props: { reference: 'irrigationTabs' },
      children: [
        IrrigationRoutes,
        {
          path: 'energysources',
          name: 'irrigation.energy_sources',
          component: EnergySources,
          meta: {
            prefix_permission: 'irrigation_energysources',
          },
        },
        {
          path: 'systems',
          name: 'irrigation.irrigation_system',
          component: IrrigationSystems,
          meta: {
            prefix_permission: 'irrigation_systems',
          },
        },
        {
          path: 'watersources',
          name: 'samples.water_sources',
          component: IrrigationWaterSource,
          meta: {
            prefix_permission: 'irrigation_watersources',
          },
        },
        {
          path: 'engine',
          name: 'irrigation.engines',
          component: Engine,
          meta: {
            prefix_permission: 'irrigation_engine',
          },
        },
        {
          path: 'engine/create',
          name: 'irrigation.engines',
          component: EngineCreateEdit,
          meta: {
            prefix_permission: 'irrigation_engine',
          },
        },
        {
          path: 'edit',
          name: 'irrigation.engines',
          component: EngineCreateEdit,
          meta: {
            prefix_permission: 'irrigation_engine',
          },
        },
        {
          path: 'observations',
          name: 'irrigation.irrigation_observations',
          component: Observations,
          meta: {
            prefix_permission: 'irrigation_observations',
          },
        },
        {
          path: 'catching',
          name: 'irrigation.irrigation_capture',
          component: Catching,
          meta: {
            prefix_permission: 'irrigation_catching',
          },
        },
        {
          path: 'forecast',
          name: 'irrigation.irrigation_forecast',
          component: IrrigationForecast,
          meta: {
            prefix_permission: 'irrigation_forecast',
          },
        },
        {
          path: 'compliance',
          name: 'irrigation.irrigation_compliance',
          component: IrrigationCompliance,
          meta: {
            prefix_permission: 'irrigation_compliance',
          },
        },
        /* Prueba */
        {
          path: 'notification',
          name: 'irrigation.irrigation_notification',
          component: NotificationIrrigation,
          meta: {
            prefix_permission: 'irrigation_notification',
          },
        },
        {
          path: 'form',
          name: 'irrigation.form',
          component: Form,
          meta: {
            prefix_permission: 'irrigation_form',
          },
        },
        {
          path: 'form/create',
          name: 'irrigation.form',
          component: FormCreateEdit,
          meta: {
            prefix_permission: 'irrigation_form',
          },
        },
        {
          path: 'form/edit',
          name: 'irrigation.form',
          component: FormCreateEdit,
          meta: {
            prefix_permission: 'irrigation_form',
          },
        },
        {
          path: 'valves',
          name: 'irrigation.valves',
          component: Valves,
          meta: {
            prefix_permission: 'irrigation_valves',
          },
        },
        {
          path: 'valves/create',
          name: 'irrigation.valves',
          component: ValvesCreateEdit,
          meta: {
            prefix_permission: 'irrigation_valves',
          },
        },
        {
          path: 'valves/edit',
          name: 'irrigation.valves',
          component: ValvesCreateEdit,
          meta: {
            prefix_permission: 'irrigation_valves',
          },
        },
        {
          path: 'catchbloodpressuremonitors',
          name: 'irrigation.blood_pressure_monitors_capture',
          component: CatchBloodPressureMonitor,
          meta: {
            prefix_permission: 'irrigation_catchbloodpressuremonitors',
          },
        },
        {
          path: 'reportbloodpressuremonitors',
          name: 'Reporte de Tensiómetros',
          component: BloodPressureMonitorReport,
          meta: {
            prefix_permission: 'irrigation_reportbloodpressuremonitors',
          },
        },

      ],
    },
    {
      path: 'widgets',
      component: MasterTab,
      props: { reference: 'widgetsTabs' },
      children: [
        {
          path: 'widgets',
          name: 'Widgets',
          component: () =>
            import('src/views/Pages/Dashboard/Widgets/Widgets/Widgets.vue'),
          meta: {
            prefix_permission: 'widgets_user',
          },
        },
        {
          path: 'user',
          name: 'widgets.user_widgets',
          component: () =>
            import(
              'src/views/Pages/Dashboard/Widgets/UserWidgets/UserWidgets.vue'
            ),
          meta: {
            prefix_permission: 'widgets_user',
          },
        },
      ],
    },
    LossRoutes,
    ExternalQualityRoutes,
    OptRoutes,
    BreakdownRoutes,
    IndividualProgressSheetRoutes,
    SecurityRoutes,
    CompetencyMatrizRoutes,
    ActivityLogRoutes,
    HourHourRoutes,
    LogPlannerRoutes,
    FinishedProductQualityRoutes,
    HarvestQualityRoutes,
    PresentismRoutes,
    ProfitExportedBoxesRoutes,
    ActivityCompletionRoutes
  ],
};

// creamos nuestra ruta para reestablecer contraseña
let passwordResetPage = {
  path: '/password_reset/:token',
  name: 'PasswordReset',
  beforeEnter: guards.auth,
  component: PasswordReset,
};

// creamos nuestra ruta loginPage
let loginPage = {
  path: '/login',
  name: 'Login',
  beforeEnter: guards.auth,
  component: Login,
};

// creamos nuestra ruta notFoundPage
let notFoundPage = {
  path: '*',
  name: 'NotFound',
  component: NotFound,
};

// creamos nuestra ruta para login con google
let loginGoogle = {
  path: '/auth/:provider/callback',
  component: {
    template: '<div class="auth-component"></div>',
  },
};

let lockPage = {
  path: '/lock',
  name: 'Lock',
  beforeEnter: guards.inactive,
  component: Lock,
};

let loginMicrosoft = {
  path: '/auth/callback',
  component: AuthCallback,
  meta: { skipAuth: true },
};

const routes = [
  homePage,
  loginPage,
  loginGoogle,
  passwordResetPage,
  notFoundPage,
  lockPage,
  loginMicrosoft,
];

export default routes;
